<template>
  <div>
    <AvatarSelection
      v-if="workSpaceData && workSpaceData.length > 0"
      :avatarData="workSpaceData"
      :moreItems="moreItems"
      @selected="selectWorkSpace"
    />
  </div>
</template>

<script>
import WorkSpaceService from "@/api/service/WorkSpace/WorkSpaceService";
import AvatarSelection from "./AvatarSelection.vue";

export default {
  props: ["displayType"],
  components: { AvatarSelection },
  data() {
    return {
      workSpaceData: [],
      moreItems: [],
    };
  },
  computed: {
    getRefreshWs() { return this.$store.getters.getMyspace; },
    getRefresh()   { return this.$store.getters.getRefreshWorkSpace; },
  },
  watch: {
    getRefreshWs() { this.markActive(); },
    getRefresh() {
      const id = localStorage.getItem("workSpaceId");
      const ws = [...this.workSpaceData, ...this.moreItems].find(k => k.id == id);
      if (ws) this.selectWorkSpace(ws);
    },
  },
  created() { this.getWorkSpaces(); },
  methods: {
    markActive() {
      const id = parseInt(localStorage.getItem("workSpaceId"));
      [...this.workSpaceData, ...this.moreItems].forEach(k => { k.active = k.id === id; k.select = k.id === id; });
      this.workSpaceData = [...this.workSpaceData];
      this.moreItems     = [...this.moreItems];
    },
    selectWorkSpace(data) {
      const status = this.$store.getters.getMyspace;
      localStorage.setItem("_WS_DEFAULTS_", JSON.stringify({ workspace: { id: data.id, name: data.name } }));
      localStorage.setItem("workSpaceId", data.id);
      this.$store.commit("WORK_SPACE_ID", data.id);
      this.$store.commit("SET_REFRESH_BREADCRUMP", true);
      this.markActive();
      this.$store.commit("CHANGE_MY_SPACE", !status);
      this.$router.push({ path: "/showProjectForWorkspaces", query: { workSpaceId: data.id } });
    },
    async getWorkSpaces() {
      try {
        let data = await WorkSpaceService.getWorkSpaceByUser({ active: 1 });
        const selectId = parseInt(localStorage.getItem("workSpaceId"));
        data.forEach(k => { k.active = k.id === selectId; k.select = k.id === selectId; });
        if (data.length > 4) this.moreItems = data.splice(4);
        this.workSpaceData = data;
        if (!selectId && data.length > 0) {
          this.$store.commit("WORK_SPACE_ID", data[0].id);
          this.markActive();
        }
      } catch (e) { console.log(e); }
    },
  },
};
</script>
